import Class from "core/util/Class";
import { nDef } from "core/util/TypeUtils";
import IOption from "../../models/IOption";

/**
 * @description hopefully a way to get type mappings off param object
 */

export const PARAMS: string = "__params__";
export const REFINE: string = "__refine__";

export enum ParamType {
	BOOLEAN = "boolean",
	STRING = "string",
	ENUM = "enum",
	INT = "int",
	CSV_LIST = "csvlist"
}

export enum RefineType {
	SELECT = "select",
	TEXT = "text"
}

const setupParams = (cls: Class<any>): boolean => {
	if (nDef(cls[PARAMS])) {
		cls[PARAMS] = { params: {} };
		return true;
	}
	return false;
};

export const Params = () => (cls: Class<any>) => {
	return cls;
};

/**
 * if global === true, ParamsWrapper does not prefix param key.
 * This can be used to share parameters accross panels where desired
 */
interface IParamArgs {
	global?: boolean;
	type: ParamType;
}

/**
 * setup metadata for a field on a parameters class
 * @param args.type - how the string value from the page params should be processed. E.g., ParamType.INT will try to parse the param as an integer
 * @param args.global - indicates that a paramsWrapper should not expect this parameter to be prefixed.
 */
export const Param = (args: IParamArgs) => (cls: any, property: string) => {
	setupParams(cls);
	cls[PARAMS].params[property] = { property, ...args };
};

export const setupRefine = (cls: any): boolean => {
	if (nDef(cls[REFINE])) {
		cls[REFINE] = { refine: {} };
		return true;
	}
	return false;
};

export interface IRefineOption extends IOption {
	default?: boolean;
	key: string;
	label: string | JSX.Element;
	icon?: any;
	value: any;
}

interface IRefineArgs {
	options?: IRefineOption[];
	label: string;
	type: RefineType;
}

export const Refine = (args: IRefineArgs) => (cls: any, property: string) => {
	setupRefine(cls);
	cls[REFINE].refine[property] = { property, ...args };
};




// WEBPACK FOOTER //
// ./src/common/entities/paramsWrapper/Params.ts